import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import type { Beat, GlobalErrorHandler } from '..'

export class BeatApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  getBeats = async (pageNum?: number, perPage?: number) => {
    const beatParams = `page=${pageNum ? pageNum : 1}&per_page=${perPage ? perPage : 5}`

    return this.fetchInstance.get(`${ApiEndpoints.BEATS}?${beatParams}`).then((data) => data.beats)
  }

  getBeatsWithAssociatedTransaction = async (fromDate?: string) => {
    let beatParams = 'has_associated_transaction_guid=true'
    beatParams += fromDate ? `&from_date=${fromDate}` : ''

    return this.fetchInstance.get(`${ApiEndpoints.BEATS}?${beatParams}`).then((data) => data.beats)
  }

  getOffers = async () => {
    return this.fetchInstance
      .get(`${ApiEndpoints.OFFERS}/${ApiEndpoints.PULSE_COMMUNICATIONS}`)
      .then((data) => data.pulse_communications)
  }

  updateBeat = async (beat: Beat) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.BEATS}/${beat.guid}`, beat)
      .then((data) => data.beat)
  }

  updateOffer = async (beat: Beat) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.OFFERS}/${beat.guid}`, beat)
      .then((data) => data.beat)
  }
}
